export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Bizi – лучший сервис объявлений в США. Все, что нужно для продажи и покупки товаров и услуг в одном месте!"},{"property":"og:title","content":"Bizi - Лучший сервис объявлений в США – Все, что нужно, в одном месте!"},{"property":"og:description","content":"Продавайте и покупайте товары и услуги в США с Bizi. Все, что нужно для бизнеса и личных нужд, в одном месте!"},{"property":"og:url","content":"https://bizi.one"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://d29wswc5m3zeg7.cloudfront.net/prod/files/bizi.jpg"},{"name":"robots","content":"index, follow"},{"name":"og:site_name","content":"BIZI"},{"name":"og:image:type","content":"image/jpeg"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"}],"style":[],"script":[],"noscript":[],"title":"Bizi - Лучший сервис объявлений в США – Все, что нужно, в одном месте!","viewport":"width=device-width, initial-scale=1"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true